import { FeedKey, Group, PublicUserProfile, UserProfile } from 'api';
import { NULL } from 'constants/index';

interface IFollowResponse {
  type: FeedKey;
  currentUser: UserProfile;
  source: Group | PublicUserProfile;
}

export const followResponse = ({ type, source, currentUser }: IFollowResponse) => {
  const nullType = type === FeedKey.User ? 'group' : 'user';

  return {
    follow: {
      created_at: -1,
      [nullType]: NULL,
      [type]: source,
      feed: type,
      postable: false,
      user_id: currentUser.id,
      __typename: 'UserFeedFollow',
    },
  };
};
